// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__QNCqX","switchLoginLink":"login_switchLoginLink__s7lOf","loginPageContainer":"login_loginPageContainer__yRtZT"};